export enum MediaInformationProperties {
  Media = 'media',
  DisableComments = 'disableComments',
  Lock = 'lock',
  Owner = 'owner',
  Id = 'id',
  Created = 'created',
  Updated = 'updated',
  Deleted = 'deleted',
  Version = 'version',
}
export enum MediaInformationMetaProperties {
  MediaId = 'Media-id',
  MediaVersion = 'Media-version',
}
